import React from 'react';
import {connect } from 'react-redux';
import {Route, Redirect, withRouter } from 'react-router-dom';

const PrivateWrapper = ({component : Component, ...rest}) => {
    if(rest.isAuth){
        return <Route{...rest} render = {(props) => <Component {...props}/>}/>
    }else{
        return <Redirect to={"/"}/>
    }
};

const mapStateToProps = (state) => {
    return {
        isAuth : state.initState.isAuth
    }
};

const mapStateToDispatch = {

};

export default withRouter(connect(mapStateToProps, mapStateToDispatch)(PrivateWrapper));


// WEBPACK FOOTER //
// ./src/components/Wrappers/PrivateWrappers.js